import styled from 'styled-components'

export const HomeWelcomeWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.visuelt};
  font-style: normal;
  .description_amount_wrapper {
    display: flex;
    padding-left: 10px;
    flex-direction: column;
  }
  .mb {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    .mb {
      display: block;
    }
    .lg {
      display: none !important;
    }
  }
  .contain-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 83%;
  }
  .welcome_save_wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .rec-carousel-wrapper {
  }
  .rec-dot_active {
    width: 40px;
    height: 0px;
    border-radius: 0;
    border: none;
    margin-top: 10px;
  }
  .rec-dot {
    width: 25px;
    height: 0px;
    border-radius: 0;
    border: none;
    margin-top: 10px;
  }

  .welcome_text {
    margin: 25px 0 47px 0;
    p {
      font-weight: 600;
      margin: 0;
      font-size: ${({ theme }) => theme.fontSize.s};
      color: ${({ theme }) => theme.colors.gray2};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        margin-top: -15px;
        font-size: ${({ theme }) => theme.fontSize.x4};
      }
    }

    h1 {
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xl};
      line-height: 14px;
      letter-spacing: 0.75px;
      color: ${({ theme }) => theme.colors.navyBlue};
      /* margin-bottom: 1px; */
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.x2};
        line-height: 24px;
        margin-bottom: 24px;
      }
    }
  }

  .rec-slider-container {
    margin: 0;
    padding: 0;
  }

  .balance_card {
    background: ${({ theme }) => theme.colors.secondPrimary};
    width: 45%;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
    .wrap_flex {
      color: white;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-around;
    }

    .description_text {
      font-size: ${({ theme }) => theme.fontSize.x2};
      font-weight: 400;
      line-height: 22px;
      margin: 0;
    }

    .amount {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xxl};
      letter-spacing: 1px;
      margin: 0;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: ${({ theme }) => theme.fontSize.x1};
      }
    }
  }

  .money_interest_card {
    width: 21%;
    margin-left: 23px;
    /* margin-right: 20px; */
    background: ${({ theme }) => theme.colors.moneyInterestCard};
    color: ${({ theme }) => theme.colors.navyBlue};

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
      margin: 0px 10px 0 10px;
      padding: 0px 20px;
    }

    .wrap_flex {
      display: flex;
      width: 100%;
      flex-direction: column-reverse;
    }
    .amount {
      font-size: ${({ theme }) => theme.fontSize.x2};
      font-weight: 600;
      margin: 0;
      margin-top: 4px;
    }

    .description_text {
      font-weight: 400;
      margin: 0;
      font-size: 11px;
      line-height: 13px;
      color: ${({ theme }) => theme.colors.black};
    }
    .icon {
      align-self: flex-end;
      margin-top: 10px;
      padding-right: 5px;
      .money_interest_card.last_child {
        display: none;
        @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
          display: block;
        }
      }

      @media (min-width: ${({ theme }) => theme.responsive.laptop}) {
        .rec-pagination {
          display: none;
        }
        .rec-item-wrapper {
        }
        .rec-carousel-item {
          padding: 0;
          margin: 0;
        }
      }
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        .rec .rec-dot_active {
          width: 22px;
          height: 5px;
          background: ${({ theme }) => theme.colors.primary};
          border-radius: 10px;
          margin-top: 8px;
        }
      }
      @media (min-width: ${({ theme }) =>
          theme.responsive.ipad}) and (max-width: ${({ theme }) =>
          theme.responsive.laptop}) {
        .icon {
          color: ${({ theme }) => theme.colors.white};
        }
      }
    }
  }
`

export const UserTask = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  .new-cards {
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04),
      0px 8px 16px rgba(96, 97, 112, 0.16);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    height: 50px;
    width: 135px;
    border-radius: 4px;
    margin-bottom: 32px;
    margin-right: 18px;
    cursor: pointer;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      margin-right: 5px;
      height: 30px;
      margin-bottom: 22px;
      width: 100px;
    }
  }
  .flex-center {
    display: flex;
    align-items: center;
    img {
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        width: 13px;
      }
    }
    p {
      margin-left: 8px;
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: #2336ff;
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: 12px;
        margin-left: 4px;
      }
    }
  }
`
